import { render } from "./BaseGeneralsEdit.vue?vue&type=template&id=2715d7db"
import script from "./BaseGeneralsEdit.vue?vue&type=script&lang=js"
export * from "./BaseGeneralsEdit.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__